import { useEffect, useContext } from 'react';

import localStorage from 'store2';
import { useLocation } from 'react-router-dom';

import useApi, { SYNC, LOGIN, RESET_PASSWORD } from 'hooks/useApi';
import UserContext from 'context/UserSessionContext';
import * as ACTIONS from 'context/actions';

import useNavigate from 'hooks/useNavigate';
import { clearAuthHeader } from 'utils/request';

export const useSyncUser = dispatch => {
  const [state] = useApi(SYNC());
  const { isLoading, isError, data: syncedUser, error } = state;

  const navigate = useNavigate();

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError && error) {
      clearAuthHeader();
      dispatch({ type: ACTIONS.USER_READY, payload: {} });
    }

    if (syncedUser) {
      dispatch({ type: ACTIONS.USER_READY, payload: syncedUser });

      if (pathname === '/') {
        navigate(syncedUser?.homepagePreferences?.route);
      }
    }
  }, [isLoading, isError, syncedUser, error, dispatch]); //eslint-disable-line
};

export const useLogin = () => {
  const { dispatch } = useContext(UserContext);
  const [state, makeRequest] = useApi();
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    if (isLoading) {
      dispatch({ type: ACTIONS.USER_LOADING });
      return;
    }

    if (isError && error) {
      clearAuthHeader();
      dispatch({ type: ACTIONS.USER_READY, payload: {} });
      return;
    }

    if (data) {
      const { user } = data;
      dispatch({ type: ACTIONS.USER_READY, payload: user });
    }
  }, [isLoading, isError, error, data, dispatch]);

  const login = ({ username, password }) => {
    const loginParams = LOGIN({
      username,
      password
    });
    makeRequest(loginParams);
  };

  return [state, login];
};

export const useResetPassword = () => {
  const [state, makeRequest] = useApi();

  const resetPassword = ({ username }) => {
    const resetPasswordParams = RESET_PASSWORD({
      username
    });
    makeRequest(resetPasswordParams);
  };

  return [state, resetPassword];
};

export const useLogout = () => {
  const { dispatch } = useContext(UserContext);

  const logout = () => {
    clearAuthHeader();
    localStorage.clearAll();
    dispatch({ type: ACTIONS.USER_READY, payload: {} });
  };

  return [logout];
};
